import { memo } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Accordion, Heading } from '@frontend/design-system';
import { TablesDataType } from '../../../dental-insurance-eligibility-report/dental-insurance-eligibility-report/types/types';
import { useInsuranceReportAccordionContext } from '../../context';

interface AccordionSectionProps {
  accordionId: keyof TablesDataType;
  accordionTitle: string;
  children: React.ReactNode;
}

export const AccordionSection = memo(({ accordionId, accordionTitle, children }: AccordionSectionProps) => {
  const { activeAccordionIds, isPrintReport, toggleAccordion } = useInsuranceReportAccordionContext();

  const isActive = isPrintReport || activeAccordionIds.has(accordionId);

  const handleAccordionChange = () => {
    toggleAccordion(accordionId);
  };
  return (
    <Accordion
      onChange={handleAccordionChange}
      controlledValue={isActive ? accordionId : null}
      css={accordionSectionStyles(isActive)}
      showBoxShadow={false}
    >
      <Accordion.Item key={accordionId} value={accordionId}>
        <Accordion.Header>
          <Heading level={3}>{accordionTitle}</Heading>
        </Accordion.Header>
        <Accordion.Body>{children}</Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
});

AccordionSection.displayName = 'AccordionSection';

const accordionSectionStyles = (isActive: boolean) =>
  css({
    border: `1px solid ${theme.colors.neutral20}`,
    borderRadius: theme.borderRadius.medium,
    '> div': {
      margin: 0,
    },
    'button:first-child': {
      background: isActive ? theme.colors.neutral5 : theme.colors.white,
    },
  });
